import { createAction } from 'redux-actions';

export const SET_SECURITY_QUESTION = 'dayPickerActions/SET_SECURITY_QUESTION';
export const setSecurityQuestion = createAction(SET_SECURITY_QUESTION);
